<!-- Port of vendor-ref/mara/app/ui/src/components/chat/ToolMessage.vue (ToolLink replaced by its icon + name). -->
<script setup lang="ts">
import { computed, ref } from 'vue';
import Button from 'primevue/button';
import Panel from 'primevue/panel';
import type { ChatMessage } from '@/mara/chat';

const props = defineProps<{ message: ChatMessage }>();

const collapsed = ref(true);

const name = computed(() => props.message.content.match(/\*\*Tool\*\*: (.+?)\n\n/m)?.[1] ?? '');
const input = computed(() => props.message.content.match(/\*\*Input\*\*: (.+?)(\n\n|$)/m)?.[1] ?? '');
const output = computed(() => props.message.content.match(/\*\*Output\*\*: (.+)$/ms)?.[1] ?? '');
</script>

<template>
  <Panel
    v-model:collapsed="collapsed"
    pt:header-actions="flex items-center"
    pt:header="flex flex-row-reverse justify-end items-center gap-2"
    pt:pc-toggle-button="rd-4"
    class="message tool-message w-full my-1 text-sm"
    data-test="tool-message"
    unstyled
  >
    <template #header>
      <div class="flex items-center gap-2 font-medium op-65">
        <i class="i-tabler-tool shrink-0" />
        {{ name }}
        <i v-if="message.status === 'error'" class="i-tabler-x shrink-0 text-red" />
      </div>
    </template>
    <template #icons>
      <Button
        :dt="{ iconOnlyWidth: '1.5rem' }"
        :icon="(!output && message.status !== 'error') ? 'i-tabler-loader-2 animate-spin' : collapsed ? 'i-tabler-chevron-right' : 'i-tabler-chevron-down'"
        severity="secondary"
        rounded
        text
        data-test="tool-toggle"
        @click="collapsed = !collapsed"
      />
    </template>
    <div
      class="my-2 ml-11px pl-4.5 flex flex-col gap-1 of-y-auto"
      style="border-left: 2px solid var(--surface-section); max-height: min(300px, 50vh)"
    >
      <div class="op-65">
        <span class="op-75">Input:</span>
        <div class="font-mono text-xs ws-pre-wrap">{{ input }}</div>
      </div>
      <div v-if="output" class="op-65">
        <span class="op-75">Output:</span>
        <div class="font-mono text-xs ws-pre-wrap" data-test="tool-output">{{ output }}</div>
      </div>
    </div>
  </Panel>
</template>

<style>
.tool-message {
  text-wrap: balance;
  word-break: break-word;
}
</style>
